<template>
	<div class="activity-record">
		<div class="inputtopp">
			<div v-for="(item, index) of formdata" :key="index" class="search-item">
				<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
					:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
					:options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
					:color="item.color" :placeholder="item.placeholder" :multiple="item.multiple" :types="item.types"
					:inputtype="item.inputtype" :width="item.width" :event="item.event">
				</Commondropdownlist>
			</div>
			<div class="Btngroups">
				<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
			</div>
		</div>

		<!-- Table -->
		<div class="table-container">
			<div class="btn-group">
				<Commonbtn backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="openEdit" v-if="qx.update"
					:useAutoOptional="false" :optional="selection.length !== 1"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="handleExport"
					:src="require('@/assets/icon/daoc.png')" />
				<Commonbtn backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="handleDelete" v-if="qx.del"
					:src="require('@/assets/icon/icon-del.png')" />
				<Commonbtn backgroundColor="#FFF" title="完成" fontSize="14px" @btnclick="handleVerify" v-if="qx.setting"
					:useAutoOptional="false" :optional="selection.length !== 1"
					:src="require('@/assets/icon/shen.png')" />
			</div>

			<ActivityRecordTable ref="table" :tableData="tableData" @onRowClick="onRowClick"
				@selectionChange="handleSelectionChange"></ActivityRecordTable>

			<div class="pagination">
				<Pagination :total="total" :current="current" :pageSize="pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Pagination>
			</div>
		</div>

		<!-- Detail Table -->
		<div class="detail-container" style="margin-top: 20px;">
			<ActivityRecordDetailTable :tableData="detailData"></ActivityRecordDetailTable>
		</div>

		<!-- Edit Dialog -->
		<ActivityRecordDialog v-if="dialogVisible" :dialogVisible="dialogVisible" :title="dialogTitle" :id="currentId"
			@cancel="dialogVisible = false" @dialogOK="handleDialogOK"></ActivityRecordDialog>
	</div>
</template>

<script>
	import Commondropdownlist from "@/components/common-dropdownlist.vue";
	import CommonBtngroup from "@/components/commongroup.vue";
	import Commonbtn from "@/components/common-btn.vue";
	import Pagination from "@/components/pagination.vue";
	import ActivityRecordTable from "./components/ActivityRecordTable.vue";
	import ActivityRecordDetailTable from "./components/ActivityRecordDetailTable.vue";
	import ActivityRecordDialog from "./components/ActivityRecordDialog.vue";
	import {
		ActivityRecordList,
		ActivityRecordDetail,
		ActivityRecordExport,
		ActivityRecordDelete,
		ActivityRecordVerify
	} from "@/api/ActivityRecord";

	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			ActivityRecordTable,
			ActivityRecordDetailTable,
			ActivityRecordDialog
		},
		data() {
			return {
				qx: {
					update: false,
					del: false,
					setting: false
				},
				formdata: [{
						title: "活动名称",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "85px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "医院",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "100px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "会议类型",
						inputtype: "input",
						inputdata: "",
						width: "180px",
						lablewith: "100px",
						placeholder: "请输入",
						fontSize: "14px",
						color: "#333333"
					},
					{
						title: "创建时间",
						inputtype: "date",
						inputdata: "",
						width: "240px",
						lablewith: "80px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333",
						types: "daterange"
					},
					{
						title: "举办时间",
						inputtype: "date",
						inputdata: "",
						width: "240px",
						lablewith: "80px",
						placeholder: "请选择",
						fontSize: "14px",
						color: "#333333",
						types: "daterange"
					}
				],
				tableData: [],
				detailData: [],
				total: 0,
				current: 1,
				pageSize: 10,
				dialogVisible: false,
				dialogTitle: "",
				currentId: null,
				selection: []
			};
		},
		mounted() {
			this.QX();
			this.select();
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.forEach((items, indexs) => {
							if (items.NodeID == 1093) {
								items.Nodes.forEach((itemes, index) => {
									if (itemes.NodeID == 1095) {
										this.qus = itemes.Buttons
									}
								})
							}
						})
					}
				});
				console.log(this.qus);
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "setting") {
							this.qx.setting = true;
						}
					});
				}
			},
			async select() {
				if (!this.$refs.seselect) return;

				let params = {
					ActivityName: this.$refs.seselect[0] ? this.$refs.seselect[0].modelvalue : '',
					Hospital: this.$refs.seselect[1] ? this.$refs.seselect[1].modelvalue : '',
					LEVEL2: this.$refs.seselect[2] ? this.$refs.seselect[2].modelvalue : '',
					CreateTime1: this.$refs.seselect[3] ? this.$refs.seselect[3].startTime : '',
					CreateTime2: this.$refs.seselect[3] ? this.$refs.seselect[3].endTime : '',
					PreConductDate1: this.$refs.seselect[4] ? this.$refs.seselect[4].startTime : '',
					PreConductDate2: this.$refs.seselect[4] ? this.$refs.seselect[4].endTime : '',
					PageIndex: this.current,
					PageSize: this.pageSize
				};

				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				try {
					let res = await ActivityRecordList(params);
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
				} finally {
					loading.close();
				}
			},
			reset() {
				this.$refs.seselect.forEach((item, index) => {
					item.modelvalue = "";
					// 清除日期范围选择器的值
					if (index === 3 || index === 4) {
						item.startTime = "";
						item.endTime = "";
					}
				});
				this.current = 1;
				this.select();
			},
			handleCurrentChange(val) {
				this.current = val;
				this.select();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.select();
			},
			async onRowClick(row) {
				if (!row || !row.ActivityCode) return;
				
				// 记录当前点击的行ID，用于高亮或其他逻辑
				this.currentId = row.ActivityCode;

				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				try {
					let res = await ActivityRecordDetail({
						ActivityCode: row.ActivityCode
					});
					if (res.code == 0) {
						this.detailData = res.data;
					}
				} finally {
					loading.close();
				}
			},
			handleSelectionChange(val) {
				// 仅当通过复选框显式操作时才更新selection，或者在onRowClick中手动同步
				this.selection = val;
			},
			handleExport() {
				let params = {
					ActivityName: this.$refs.seselect[0] ? this.$refs.seselect[0].modelvalue : '',
					Hospital: this.$refs.seselect[1] ? this.$refs.seselect[1].modelvalue : '',
					LEVEL2: this.$refs.seselect[2] ? this.$refs.seselect[2].modelvalue : '',
					CreateTime1: this.$refs.seselect[3] ? this.$refs.seselect[3].startTime : '',
					CreateTime2: this.$refs.seselect[3] ? this.$refs.seselect[3].endTime : '',
					PreConductDate1: this.$refs.seselect[4] ? this.$refs.seselect[4].startTime : '',
					PreConductDate2: this.$refs.seselect[4] ? this.$refs.seselect[4].endTime : '',
				};
				ActivityRecordExport(params).then(res => {
					const blob = new Blob([res]);
					const fileName = '活动记录.xlsx';
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
					window.URL.revokeObjectURL(link.href);
				});
			},
			handleDelete() {
				if (this.selection.length === 0) {
					this.$message.warning('请选择要删除的记录');
					return;
				}
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let codes = this.selection.map(item => item.ActivityCode);
					let res = await ActivityRecordDelete({
						ActivityCodes: codes
					});
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.select();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			openEdit() {
				if (this.selection.length !== 1) {
					this.$message.warning('请选择一条数据进行修改');
					return;
				}
				this.currentId = this.selection[0].ActivityCode;
				this.dialogTitle = "修改活动记录";
				this.dialogVisible = true;
			},
			async handleVerify() {
				if (this.selection.length !== 1) {
					this.$message.warning('请选择一条数据进行完成');
					return;
				}
				this.submitVerify();
			},
			async submitVerify(isForce) {
				let params = {
					ActivityCode: this.selection[0].ActivityCode
				};
				if (isForce !== undefined) {
					params.IsForce = isForce;
				}
				
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				
				try {
					let res = await ActivityRecordVerify(params);
					if (res.code == 0) {
						this.$message.success('操作成功');
						this.select();
					} else if (res.code == 300) {
						let html = res.message + '<br>';
						if (res.data && res.data.length > 0) {
							res.data.forEach(msg => {
								html += `${msg}<br>`;
							});
						}
						this.$confirm(html, '提示', {
							dangerouslyUseHTMLString: true,
							confirmButtonText: '覆盖',
							cancelButtonText: '不覆盖',
							distinguishCancelAndClose: true,
							type: 'warning'
						}).then(() => {
							this.submitVerify(1);
						}).catch(action => {
							if (action === 'cancel') {
								this.submitVerify(0);
							}
						});
					} else {
						this.$message.error(res.message || '操作失败');
					}
				} catch (error) {
					const errorMessage = error.response?.data?.message || '操作失败';
					this.$message.error(errorMessage);
				} finally {
					loading.close();
				}
			},
			async handleDialogOK() {
				this.dialogVisible = false;
				await this.select();
				if (this.currentId) {
					this.onRowClick({
						ActivityCode: this.currentId
					});
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.inputtopp {
		width: 100%;
		height: auto;
		min-height: 85px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 5px;
		position: relative;
		transition: all 0.3s;
		margin-bottom: 10px;
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
	}

	.search-item {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.Btngroups {
		margin-left: auto;
		margin-top: 5px;
		margin-right: 20px;
		margin-bottom: 10px;
	}

	.table-container {
		background-color: #fff;
		padding: 10px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.btn-group {
		margin-bottom: 10px;
	}

	.detail-container {
		background-color: #fff;
		padding: 10px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.detail-title {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 10px;
		color: #333;
		padding-left: 10px;
		border-left: 4px solid #409EFF;
	}
</style>
